import { reactive } from "vue";
import parseJson from "../parse-json";
import {
  BackendFetch,
  LegacyInventoryItem,
  LegacyStock
} from '@hantera/portal-app';

const index: {
  [itemId: string]: LegacyInventoryItem[]
} = {};

export default function (portalFetch: BackendFetch) {

  return {

    /**
     * Gets the stock for the specified items
     * @param orderId
     */
    async get(itemNumbers: string[]): Promise<LegacyStock | undefined> {
      const result: LegacyStock = {};

      itemNumbers.forEach(i => {
        const existing = index[i];
        if (existing) {
          result[i] = existing;
        } else {
          index[i] = reactive([]);
          result[i] = index[i];
        }
      });

      await refreshStock(itemNumbers);

      return result;
    },
  };

  async function refreshStock(itemNumbers: string[]) {
    const res = await portalFetch('/legacy-stock', {
      method: 'POST',
      body: JSON.stringify({
        itemNumbers
      }),
    });

    if (res.ok) {
      const data = parseJson(await res.text());
      for (const itemNumber in data) {
        index[itemNumber].splice(0, index[itemNumber].length);
        index[itemNumber].push(...data[itemNumber]);
      }
    }
  }

  // function addOrUpdateStore(order: Order) {
  //   const existing = index[order.orderId];
  //   if (existing) {
  //     cleanAssign(existing, order);
  //   } else {
  //     index[order.orderId] = <any>reactive<Order>(order);
  //   }
  // }

}